/**
 *
 * Asynchronously loads the component for DirectionsPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
